import { Components } from '@mui/material';

import variants from 'components/table/variants';

import { colors } from 'theme/colors';
import typography from 'theme/typography';

const tableHead: Components['MuiTableHead'] = {
  styleOverrides: {
    root: {
      '& .MuiTableCell-root': {
        color: colors.primary.dark,
        fontSize: typography.caption1_Regular.fontSize,
        borderTop: `1px solid ${colors.border.light}`,
        background: colors.table.headerBackground,
        textAlign: 'left',
        padding: '10px 16px !important',
        fontWeight: 700,

        [`&.${variants.thead.withoutBorderBottom}`]: {
          borderBottom: 'none',
        },

        [`&.${variants.thead.withBorderBottom}`]: {
          borderBottom: `1px solid ${colors.border.main}`,
          paddingTop: '10px',
          paddingBottom: '10px',
          borderSpacing: '20px',
        },

        [`&.${variants.thead.highlight}`]: {
          background: colors.background.dark,
        },
      },
    },
  },
};

export default tableHead;
